import svg from './row-svg/couleur-text.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CouleurTextIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CouleurTextIcon;
